import Vue from "vue"
import VueI18n from "vue-i18n"

const resources = require("./apicella-bundle.json")

Vue.use(VueI18n)

if (!localStorage.getItem("lang")) localStorage.setItem("lang", "it-IT")

export const i18n = new VueI18n({
	locale: localStorage.getItem("lang"),
	fallbackLocale: "it-IT",
	messages: resources
})
